import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { useSite, UI } from "@/lib/site";
import { Logo } from "@/components/Logo";
import { InstaButton } from "@/components/WaButton";

export const Footer = () => {
  const { t, wa, content } = useSite();
  const c = content?.contacts || {};
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0e0c0a] text-[#e9dfcc]">
      <div className="gold-line h-px w-full opacity-60" />
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 md:grid-cols-12 md:px-10 md:py-20">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#cbbfa9]">{t(content?.about?.lead)}</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow !text-[#e6ca7a]">{t(UI.directions)}</p>
          <ul className="mt-5 space-y-3 text-sm">
            {(content?.directions || []).map((d) => (
              <li key={d.slug}>
                <Link to={`/direction/${d.slug}`} className="text-[#e9dfcc] transition-colors duration-300 hover:text-[#e6ca7a]" data-testid={`footer-link-${d.slug}`}>{t(d.title)}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow !text-[#e6ca7a]">{t(UI.nav.contacts)}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a href={wa()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#e6ca7a]" data-testid="footer-phone"><Phone className="h-4 w-4 text-[#e6ca7a]" />{c.phone}</a></li>
            <li><a href={`mailto:${c.email}`} className="flex items-center gap-3 hover:text-[#e6ca7a]" data-testid="footer-email"><Mail className="h-4 w-4 text-[#e6ca7a]" />{c.email}</a></li>
            <li><a href={`https://instagram.com/${c.instagram}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#e6ca7a]" data-testid="footer-instagram"><Instagram className="h-4 w-4 text-[#e6ca7a]" />@{c.instagram}</a></li>
            <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-[#e6ca7a]" />{t(c.address)}</li>
          </ul>
          <a href={wa()} target="_blank" rel="noopener noreferrer" className="btn-gold mt-7" data-testid="footer-whatsapp-btn"><MessageCircle className="h-4 w-4" />{t(UI.writeWa)}</a>
          <InstaButton dark className="ml-0 mt-3 sm:ml-3" testId="footer-instagram-btn" />
        </div>
      </div>
      <div className="font-display pointer-events-none select-none whitespace-nowrap px-5 text-center text-[19vw] leading-[0.8] text-[#1c1712]" aria-hidden="true">Dari event</div>
      <div className="mx-auto flex max-w-[1400px] flex-col justify-between gap-2 border-t border-[#e6ca7a]/10 px-5 py-6 text-xs text-[#a89c87] sm:flex-row md:px-10">
        <span>© {new Date().getFullYear()} Dari Event · ОсОО «Асылбашев Креатив». {t(UI.rights)}.</span>
        <Link to="/admin" className="hover:text-[#e6ca7a]" data-testid="footer-admin-link">Admin</Link>
      </div>
    </footer>
  );
};
